import { Modal } from "antd";
import {
  Button,
  Content,
  Footer,
  RechargeRule,
  Title,
  RuleWrapper,
  ModalStyle,
} from "./atom";

const RuleModal: React.FC<{
  type: "recharge" | "vip";
  ruleList?: string[];
  open?: boolean;
  setRuleOpen?: (state: boolean) => void;
  className?: string;
}> = ({
  type = "vip",
  ruleList = [],
  open = false,
  setRuleOpen = () => {},
  className = "client-rule",
}) => {
  return (
    <RuleWrapper className={className}>
      {ruleList.length > 0 && (
        <>
          <RechargeRule
            onClick={() => setRuleOpen(true)}
            className={`${className}-text`}
          >
            {type === "recharge" ? "充值规则" : "会员规则"}
          </RechargeRule>
          <Modal
            wrapClassName="rule-modal"
            open={open}
            width={520}
            footer={null}
            onCancel={() => setRuleOpen(false)}
            centered
          >
            <Title>{type === "recharge" ? "充值规则" : "会员规则"}</Title>
            <Content>
              {ruleList?.map((item, index) => {
                return <div key={item}>{item}</div>;
              })}
            </Content>
            <Footer>
              <Button onClick={() => setRuleOpen(false)}>我知道了</Button>
            </Footer>
          </Modal>
          <ModalStyle />
        </>
      )}
    </RuleWrapper>
  );
};
export default RuleModal;
